import { Enum } from './Enum';

export class DocumentCategoryTypeEnum extends Enum {
    static Request = 'request';
    static RequestForm = 'request_form';
    static Regulation = 'regulation';
}

